<template>
<div>
    <v-list two-line>
      <v-list-item-group
        v-model="selected"
        active-class="pink--text"
        multiple
      >
        <template v-for="(item, index) in items">
          <v-list-item :key="item.title">
            <template v-slot:default="{ active }">
              <v-list-item-content>
                  {{item.ownerKiosk}}
                <v-list-item-title v-text="`${item.__t} -- ${item.state} -- File at path : ${item.responseFromKiosk}`">
                  
                </v-list-item-title>

                <v-list-item-subtitle
                  class="text--primary"
                  v-text="item._id"
                ></v-list-item-subtitle>

                <v-list-item-subtitle v-text="item.createdAt"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text v-text="item.action"></v-list-item-action-text>

                <v-icon
                  v-if="!active"
                  color="grey lighten-1"
                >
                  mdi-delete-outline
                </v-icon>

                <v-icon
                  v-else
                  color="red darken-3"
                >
                  mdi-delete
                </v-icon>
              </v-list-item-action>
            </template>
          </v-list-item>

          <v-divider
            v-if="index < items.length - 1"
            :key="index"
          ></v-divider>
        </template>
      </v-list-item-group>
    </v-list>

    <v-btn
    bottom
    fab
    fixed
    outlined
    right
    @click="handleRemove()"
    > OK</v-btn>

</div>
     
</template>





<script>

import axios from 'axios';
  export default {
    data: () => ({
      selected: [],
      items: [

      ],
    }),
    mounted(){
        this.refreshDatas();
    },
    computed:{
      refreshItems : function(freshItems){
        return freshItems;
      }
    },
    methods: {
                refreshDatas: async function() {
                          let that = this;
                        var config = {
                            method: 'get',
                            url: process.env.VUE_APP_API_EXT_URL+'/jobs',
                            headers: { Authorization: 'Bearer '+localStorage.getItem('jwt')}
                        };

                        await axios(config)
                          .then(function (response) {
                            that._data.items = response.data;
                          })
                        .catch(function (error) {
                              console.log(error);
                        });

                        
                   },
                   handleRemove:function(){

                     new Promise((resolve)=>{
                         this.selected.forEach((ind, i, array)=>{
                        let jobId = this.items[ind]._id;
                        let kioskName = this.items[ind].ownerKiosk;

                        this.callDelete(jobId, kioskName);
                        if(i === array.length-1){
                          resolve();
                        }
                     });
                     }).then(()=>{
                        window.location.reload();
                     })
                    
                        
                     
                   },
                   callDelete:function(jobId, kioskName){

                     var config = {
                            method: 'delete',
                            url: process.env.VUE_APP_API_EXT_URL+'/job/'+jobId+'/'+kioskName,
                            headers: { Authorization: 'Bearer '+localStorage.getItem('jwt')}
                        };

                        axios(config)
                          .then(function (response) {
                             console.log(response.data);
                          })
                        .catch(function (error) {
                              console.log(error);
                        });

                   }
    }
  }
</script>